import AttachFileIcon from '@mui/icons-material/AttachFile';
import {FormControl, InputAdornment} from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import {useField, useFormikContext} from 'formik';
import {YSLabelState} from 'main/utility/AppContextProvider/YSTheme';
import {notEmpty} from 'main/utility/CommonUtil';
import {getFieldLabel} from 'main/utility/LayoutUtil';
import {MuiFileInput} from 'mui-file-input';
import PropTypes from 'prop-types';
import {useState} from 'react';

const AppFilePicker = (props) => {
  const {maxfilesizemb = 1, filetype = []} = props;
  const [field, meta] = useField(props);
  const {setFieldValue} = useFormikContext();

  const [selectedFile, setSelectedFile] = useState(null);
  const [internalError, setInternalError] = useState('');
  const errorText = (meta.touched && meta.error) || internalError;

  const handleFile = (file) => {
    // 1. Handle Clearing
    if (!file) {
      setSelectedFile(null);
      if (field.value) {
        setFieldValue('removeFile', field.value);
      }
      setFieldValue(field.name, '');
      setFieldValue('fileInput', null);
      return;
    }

    // 2. Validation
    if (filetype.length > 0 && !filetype.includes(file.type)) {
      setInternalError(`Invalid file type. Allowed: ${filetype.join(', ')}`);
      return;
    }

    if (file.size > maxfilesizemb * 1024 * 1024) {
      setInternalError(`Max size is ${maxfilesizemb}MB.`);
      return;
    }

    // 3. Success Logic
    setInternalError('');
    setSelectedFile(file);

    // Track if we are replacing an existing file
    if (notEmpty(field.value) && field.value != file.name) {
      setFieldValue('removeFile', field.value);
    }

    setFieldValue(field.name, file.name); // Stores string name in the main field
    setFieldValue('fileInput', file); // Stores the binary for the API
  };

  return (
    <FormControl error={!!errorText} fullWidth>
      <MuiFileInput
        {...field}
        value={selectedFile}
        label={getFieldLabel(props.label, props.required)}
        onChange={handleFile}
        placeholder={field.value || 'Select...'}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <AttachFileIcon />
            </InputAdornment>
          ),
        }}
        inputProps={{accept: filetype?.join(',')}}
        sx={{
          // Ensure the pointer cursor is on the whole field
          '& .MuiInputBase-root .MuiFileInput-placeholder': {
            fontSize: 13, // Dropping to 13px for technical density
            fontWeight: 500, // Keeps it sharp and "Surgical"
            color: YSLabelState.default,
            letterSpacing: '0.02em',
            lineHeight: 1,
          },
        }}
      />
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

AppFilePicker.propTypes = {
  widgetid: PropTypes.string,
  labelid: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  maxfilesizemb: PropTypes.number,
  filetype: PropTypes.array,
};

export default AppFilePicker;
